import { Modal as OriginModal } from './embellish';
import staticRender, { withInfo, withConfirm } from './embellish/staticRender';
import destroyFns from './basics/destroyFns';

import type { ConfirmModalFnProps, ConfirmModalProps, StaticRenderModalConfig } from './embellish';
import type { ModalWrapProps } from './basics/wrap';

export type {
  ModalWrapProps as ModalProps,
  ConfirmModalFnProps,
  StaticRenderModalConfig,
  ConfirmModalProps
}

export type ModalFunc = (props: ConfirmModalFnProps) => {
  destroy: () => void;
  update: (configUpdate: ConfirmModalProps) => void;
};

export type ModalStaticFunctions = {
  info: ModalFunc;
  alert: ModalFunc;
  destroyAll: () => void;
};

export type ModalType = typeof OriginModal & ModalStaticFunctions;

const Modal = OriginModal as ModalType;

Modal.info = (props) => {
  return staticRender(withInfo(props));
};

Modal.alert = (props) => {
  return staticRender(withConfirm(props));
};

Modal.destroyAll = () => {
  while(destroyFns.length) {
    const close = destroyFns.pop();
    if (close) {
      close();
    }
  }
}

export default Modal;